/// <reference types="vite/client" />
import { APP } from './constants';

const ENV = import.meta.env;

export const isProd = () => ENV.PROD;

export const CONFIG = {
  // Web app config
  APP_NAME: isProd() ? ENV.VITE_NAME : APP.name,
  DISPLAY_NAME: isProd() ? ENV.VITE_NAME : APP.displayName,
  SOURCE: isProd() ? ENV.VITE_SOURCE : 'web',
  APP_URL: isProd() ? ENV.VITE_URL : 'http://localhost:3000',
  API_URL: isProd() ? ENV.VITE_API_URL : 'http://localhost:4000',
  SOCKET_URL: isProd() ? ENV.VITE_SOCKET_URL : 'http://localhost:4000',
  FILES_URL: isProd() ? ENV.VITE_FILE_URL : 'https://cdn.worklage.com/surgy/',
  PLAY_STORE_URL: isProd() ? ENV.VITE_PLAY_STORE : APP.play_store_url,
  TERMS_OF_USE_URL: isProd() ? ENV.VITE_TERMS_OF_USE_URL : APP.terms_of_use_url,
  PRIVACY_POLICY_URL: isProd() ? ENV.VITE_PRIVACY_POLICY_URL : APP.privacy_policy_url,
  LOGO_URL: isProd() ? ENV.VITE_LOGO : APP.logo_url,
  BANNER_URL: isProd() ? ENV.VITE_BANNER : APP.banner_url,
  TITLE: isProd() ? ENV.VITE_TITLE : APP.title,
  DESCRIPTION: isProd() ? ENV.VITE_DESCRIPTION : APP.description,

  // // Mobile app config.
  // APP_NAME: APP.name,
  // DISPLAY_NAME: APP.displayName,
  // SOURCE: APP.source,
  // APP_URL: APP.url,
  // API_URL: APP.api,
  // SOCKET_URL: APP.socket,
  // FILES_URL: APP.files,
  // PLAY_STORE_URL: APP.play_store_url,
  // TERMS_OF_USE_URL: APP.terms_of_use_url,
  // PRIVACY_POLICY_URL: APP.privacy_policy_url,
  // LOGO_URL: APP.logo_url,
  // BANNER_URL: APP.banner_url,
  // TITLE: APP.title,
  // DESCRIPTION: APP.description,

  FACEBOOK_ID: '745658646544620',
  FACEBOOK_TOKEN: '33a5c2a0d4ac9d6b4d8797ff7b41a67c',
  GOOGLE_ID: '172577191738-sfggeu22tbenc85nnobenk0qth3j3v4i.apps.googleusercontent.com',

  GIPHY_KEY: 'qKAxbU2aK5heEN0IPc7i60J71mojPXZW',

  PAGE_LIMIT: 20,
  PAGE_LIMIT_LARGE: 30,

  CLIENT_CACHE_STALE_TIME: 60 * 1000 * 10, // 10 Minutes

  MIXPANEL_PROJECT_TOKEN: '3ef23e1fc9a8a1d6845a819911ad4ae6',
  MIXPANEL_PROJECT_SECRET: '9c76d5c46c8ef252bef43a620987a810',

  BOT_UUID: 'a256446d-49e1-44fe-854d-36d6c7d89ada',
  ADMIN_UUID: 'ee49321a-c457-41ef-8865-3027040afd3c',

  MAIN_COLOR: '#005ee6',
  MAIN_COLOR_DARK: '#0043A3',
  MAIN_COLOR_LIGHT: '#0069ff',
  SKYBLUE_COLOR: '#35c1f0',
  BLUE_COLOR: '#4285F4',
  RED_COLOR: '#DB4437',
  GREEN_COLOR: '#0F9D58',
  YELLOW_COLOR: '#F4B400',

  ICE_SERVERS: [
    { url: 'stun:stun.l.google.com:19302' },
    { url: 'stun:stun1.l.google.com:19302' },
    { url: 'stun:stun2.l.google.com:19302' },
    { url: 'stun:stun3.l.google.com:19302' },
    { url: 'stun:stun4.l.google.com:19302' }
  ]
} as any;
